import React, { useEffect, useMemo, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TableTop from "./../../../component/atoms/layout/table/tableTop";
import TableCount from "./../../../component/molecules/tableCount";
import SearchBar from "./../../../component/atoms/input/searchBar";
import { route } from "../../../router/route";
import { toast } from "react-toastify";
import { errorHandler } from "../../../util/errorHandler";
import RedBtn from "./../../../component/atoms/button/redBtn";
import Modal from "../../../component/templates/Modal";
import Pagination from "./../../../component/molecules/pagination";
import Table from "../../../component/atoms/layout/table/table";
import Tr from "./../../../component/atoms/layout/table/tr";
import Th from "./../../../component/atoms/layout/table/th";
import Checkbox from "./../../../component/atoms/input/checkbox";
import TableText from "./../../../component/atoms/text/table/tableText";
import Td from "./../../../component/atoms/layout/table/td";
import EventBtn from "../../../component/atoms/button/eventBtn";
import Popup from "../../../component/molecules/popup";
import PopupOverLay from "./../../../component/templates/PopupOverlay";
import PretendardText from "../../../component/atoms/text/pretendardText";
import GrayBtn from "./../../../component/atoms/button/grayBtn";
import BlueBtn from "./../../../component/atoms/button/blueBtn";
import MainInput from "../../../component/atoms/input/mainInput";
import DateInput from "./../../../component/atoms/input/dateInput";
import LimitedMemberApi from "../../../api/limitedMember.api.";
import MemberApi from "../../../api/member.api";
import moment from "moment";

const UserPurchaseLimit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState("");
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.user_purchase_limit)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    getLimitedUserList();
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 페이지네이션 관련 ---------- //
  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 5, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  // ---------- 구매제한 회원 목록 가져오기 ---------- //
  const [limitedUserList, setLimitedUserList] = useState([]);

  const getLimitedUserList = async () => {
    try {
      const data = {
        page: page,
        size: pagination.size,
      };

      if (searchParams.get("keyword") !== null) {
        data.keyword = searchParams.get("keyword");
      }

      const response = (await LimitedMemberApi.getList(data)).data.data;
      const processedData = [...response.content].map((item, index) => {
        return {
          ...item,
          checked: false,
        };
      });

      setLimitedUserList(processedData);

      setPagination({
        ...pagination,
        totalCount: response.totalCount,
        totalPages: response.totalPage || Math.ceil(response.totalCount / 5),
        first: response.first,
        last: response.last,
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 사용자 추가 관련 ---------- //
  const [popupOpen, setPopupOpen] = useState(false);

  const [addSearchInputValue, setAddSearchInputValue] = useState("");
  const [addSearchResultList, setAddSearchResultList] = useState([]);
  const [addSearchSelectedList, setAddSearchSelectedList] = useState([]);
  const [addSearchResultIsEmpty, setAddSearchResultIsEmpty] = useState(false);

  const initialSubmitValue = {
    memberIdList: [],
    startDate: "",
    endDate: "",
    reason: "",
  };
  const [submitValue, setSubmitValue] = useState(initialSubmitValue);

  useEffect(() => {
    if (popupOpen) {
      setAddSearchInputValue("");
      setAddSearchResultList([]);
      setAddSearchSelectedList([]);
      setAddSearchResultIsEmpty(false);
      setSubmitValue(initialSubmitValue);
    }
  }, [popupOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  // 사용자 추가 검색
  const addSearchFunc = async () => {
    const data = {
      page: 1,
      size: 0,
      keyword: addSearchInputValue,
    };

    try {
      const response = (await MemberApi.getList(data)).data.data.content;
      const processedData = [...response].filter((item) => {
        return !addSearchSelectedList.some((selectedItem) => {
          return selectedItem.id === item.id;
        });
      });

      if (processedData.length === 0) {
        setAddSearchResultIsEmpty(true);
      } else {
        setAddSearchResultIsEmpty(false);
      }

      setAddSearchResultList(processedData);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    if (addSearchInputValue !== "") {
      addSearchFunc();
    }
  }, [addSearchSelectedList]); // eslint-disable-line react-hooks/exhaustive-deps

  // 사용자 추가
  const addLimitedMember = async () => {
    if (submitValue.memberIdList.length === 0) {
      toast("사용자를 선택해주세요.");
      return;
    } else if (submitValue.reason === "") {
      toast("사유를 입력해주세요.");
      return;
    } else if (submitValue.startDate === "") {
      toast("시작일을 선택해주세요.");
      return;
    } else if (submitValue.endDate === "") {
      toast("종료일을 선택해주세요.");
      return;
    }
    try {
      await LimitedMemberApi.create(submitValue);
      toast("추가되었습니다.");
      setPopupOpen(false);
      getLimitedUserList();
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 날짜 관련 ---------- //
  // 오늘 날짜를 YYYY-MM-DD 형식으로 반환하는 함수
  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // YYYY-MM-DD 형식으로 변환
  };

  const today = getTodayDate();

  const getEndDate = (startDate, endDateType) => {
    const date = new Date(startDate);

    switch (endDateType) {
      case "1주일":
        date.setDate(date.getDate() + 7);
        break;
      case "1개월":
        date.setMonth(date.getMonth() + 1);
        break;
      case "3개월":
        date.setMonth(date.getMonth() + 3);
        break;
      default:
        break;
    }

    return date.toISOString().split("T")[0];
  };

  // ---------- 해제 및 체크 관련 ---------- //
  const isAllCheck = useMemo(() => {
    const checkedList = limitedUserList.filter((item) => item.checked);
    return (
      checkedList.length !== 0 && checkedList.length === limitedUserList.length
    );
  }, [limitedUserList]);

  const [buttonGroupOpen, setButtonGroupOpen] = useState(false);

  useEffect(() => {
    const checkedList = limitedUserList.filter((item) => item.checked);
    if (checkedList.length > 0) {
      setButtonGroupOpen(true);
    } else {
      setButtonGroupOpen(false);
    }
  }, [limitedUserList]);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [delIdList, setDelIdList] = useState([]);

  const deleteFunc = async () => {
    try {
      let data = {
        ids: delIdList,
        allFlag: false,
      };
      await LimitedMemberApi.delete(data);
      toast("해제되었습니다.");
      setDeleteModalOpen(false);
      setDelIdList([]);
      getLimitedUserList();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle
            style={{
              marginBottom: 10,
            }}
          >
            구매제한 회원
          </TableTitle>
          <PretendardText
            style={{
              fontWeight: 500,
              fontSize: 13,
              lineHeight: "18.75px",
              color: "#aaa",
              marginBottom: 24,
            }}
          >
            · 특정 사용자의 상품 구매와 댓글 및 게시물 등록을 제한합니다
          </PretendardText>
          {/* 테이블 상단 영역 */}
          <TableTop>
            <TableCount text={"구매제한"} count={""} />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <SearchBar
                value={keyword}
                placeholder={"이름, 아이디(이메일), 닉네임"}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    if (keyword !== "") {
                      navigate(
                        `${route.user_purchase_limit}?page=1&keyword=${keyword}`,
                        {
                          replace: true,
                        }
                      );
                    } else {
                      navigate(route.user_purchase_limit, {
                        replace: true,
                      });
                    }
                  }
                }}
                onClick={() => {
                  navigate(
                    `${route.user_purchase_limit}?page=1&keyword=${keyword}`,
                    {
                      replace: true,
                    }
                  );
                }}
              />
              {isWriteAuthority && (
                <EventBtn
                  onClick={() => {
                    setPopupOpen(true);
                  }}
                  text={"사용자 추가"}
                />
              )}
            </div>
          </TableTop>

          {/* 버튼 그룹 */}
          {buttonGroupOpen && isWriteAuthority && (
            <div
              style={{
                width: "100%",
                height: 49,
                display: "flex",
                gap: 12,
              }}
            >
              <RedBtn
                style={{
                  backgroundColor: "#272829",
                }}
                onClick={() => {
                  const delList = limitedUserList.filter(
                    (item) => item.checked
                  );
                  if (delList.length <= 0) {
                    return;
                  }
                  setDelIdList(delList.map((item) => item.id));
                  setDeleteModalOpen(true);
                }}
              >
                구매제한 해제하기
              </RedBtn>
            </div>
          )}

          {/* 테이블 영역 */}
          <Table>
            <colgroup>
              {/* 합계: 1044px */}
              {/* 체크박스 */}
              <col width="64px" />
              {/* 이름/아이디(이메일) */}
              <col width="240px" />
              {/* 닉네임 */}
              <col width="184px" />
              {/* 사유 */}
              <col width="184px" />
              {/* 설정일 */}
              <col width="123px" />
              {/* 시작일 */}
              <col width="123px" />
              {/* 종료일 */}
              <col width="126px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "41px", background: "#272829" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={isAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setLimitedUserList(
                          limitedUserList.map((item) => {
                            return {
                              ...item,
                              checked: true,
                            };
                          })
                        );
                      } else {
                        setLimitedUserList(
                          limitedUserList.map((item) => {
                            return {
                              ...item,
                              checked: false,
                            };
                          })
                        );
                      }
                    }}
                  />
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    이름/아이디(이메일)
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    닉네임
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    사유
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    설정일
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    시작일
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    종료일
                  </TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {limitedUserList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{
                      height: "74px",
                      padding: "20px 0px",
                      background: "transparent",
                      borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                    }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={item.checked}
                        onChange={() => {
                          item.checked = !item.checked;
                          setLimitedUserList([...limitedUserList]);
                        }}
                      />
                    </Td>
                    <Td>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <TableText
                          style={{
                            maxWidth: 166,
                          }}
                        >
                          {item?.member?.name || ""}
                        </TableText>
                        <TableText
                          style={{
                            maxWidth: 166,
                          }}
                        >
                          {item?.member?.email || ""}
                        </TableText>
                      </div>
                    </Td>
                    <Td>
                      <TableText>{item?.member?.nickname || ""}</TableText>
                    </Td>
                    <Td>
                      <TableText>{item?.reason || ""}</TableText>
                    </Td>
                    <Td>
                      <TableText>
                        {moment(item.createdAt).format("YYYY-MM-DD")}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText>
                        {moment(item.startDate).format("YYYY-MM-DD")}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText>
                        {moment(item.endDate).format("YYYY-MM-DD")}
                      </TableText>
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          {/* 페이지네이션 영역 */}
          <Pagination
            route={route.user_purchase_limit}
            queryString={
              keyword ? `keyword=${searchParams.get("keyword")}` : ""
            }
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
            first={pagination.first}
            last={pagination.last}
          />
        </DetailPageLayout>
      </MainLayout>

      {/* 삭제 모달 */}
      {deleteModalOpen && (
        <Modal
          type="negative"
          title="해제하시겠습니까?"
          setModalOpen={setDeleteModalOpen}
          onClick={deleteFunc}
        />
      )}

      {/* 쿠폰 적용 상품 선택 팝업 */}
      {popupOpen && (
        <PopupOverLay
          isOpen={true}
          onClick={() => {
            setPopupOpen(false);
          }}
        >
          <Popup
            style={{
              width: 759,
            }}
            headerTitle="구매제한 회원 추가"
            footerBtnText="추가하기"
            onClick={() => {
              setPopupOpen(false);
            }}
            footerBtnHandler={() => {
              addLimitedMember();
            }}
          >
            <div
              style={{
                width: "100%",
                height: "100%",
                padding: "0px 30px",
                margin: "16px 0px 20px 0px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                gap: 32,
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <PretendardText
                  style={{
                    fontSize: "15px",
                    fontWeight: "400",
                    lineHeight: "22px",
                    color: "#aaa",
                    marginBottom: 16,
                  }}
                >
                  이름, 아이디(이메일), 닉네임으로 검색하고 선택 버튼을 누르면
                  반영됩니다.
                </PretendardText>
                <SearchBar
                  style={{
                    backgroundColor: "#313233",
                  }}
                  value={addSearchInputValue}
                  onChange={(e) => {
                    setAddSearchInputValue(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (addSearchInputValue === "") {
                      setAddSearchResultList([]);
                      setAddSearchResultIsEmpty(false);
                      return;
                    } else if (e.key === "Enter") {
                      addSearchFunc();
                    }
                  }}
                  onClick={() => {
                    if (addSearchInputValue === "") {
                      setAddSearchResultList([]);
                      setAddSearchResultIsEmpty(false);
                      return;
                    }
                    addSearchFunc();
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    // alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    height: "fit-content",
                  }}
                >
                  {/* 검색 결과 */}
                  <div
                    className="custom-scrollbar"
                    style={{
                      marginTop: 16,
                      width: "340px",
                      maxHeight: 140,
                      overflowY: "auto",
                      display: "flex",
                      flexDirection: "column",
                      gap: 12,
                    }}
                  >
                    {addSearchResultIsEmpty && (
                      <PretendardText
                        style={{
                          fontSize: "14px",
                          fontWeight: "400",
                          lineHeight: "22px",
                          color: "#aaa",
                        }}
                      >
                        검색 결과가 없습니다.
                      </PretendardText>
                    )}
                    {addSearchResultList.map((item, index) => {
                      return (
                        <div
                          key={index}
                          style={{
                            width: "100%",
                            height: "fit-content",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <PretendardText
                            className="truncate"
                            style={{
                              width: 260,
                              fontSize: "14px",
                              fontWeight: "500",
                              lineHeight: "22px",
                              letterSpacing: "-0.3%",
                              color: "#aaa",
                            }}
                          >
                            {item.name} / {item.email} / {item.nickname}
                          </PretendardText>
                          <BlueBtn
                            style={{
                              backgroundColor: "transparent",
                            }}
                            onClick={() => {
                              setAddSearchSelectedList([
                                ...addSearchSelectedList,
                                item,
                              ]);

                              setSubmitValue({
                                ...submitValue,
                                memberIdList: [
                                  ...submitValue.memberIdList,
                                  item.id,
                                ],
                              });
                            }}
                          >
                            선택
                          </BlueBtn>
                        </div>
                      );
                    })}
                  </div>

                  {/* 선택된 계정 */}
                  <div
                    className="custom-scrollbar"
                    style={{
                      marginTop: 16,
                      width: "340px",
                      maxHeight: 140,
                      overflowY: "auto",
                      display: "flex",
                      flexDirection: "column",
                      gap: 12,
                    }}
                  >
                    {addSearchSelectedList.map((item, index) => {
                      return (
                        <div
                          style={{
                            width: "100%",
                            height: "fit-content",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <PretendardText
                            className="truncate"
                            style={{
                              width: 260,
                              fontSize: "14px",
                              fontWeight: "500",
                              lineHeight: "22px",
                              letterSpacing: "-0.3%",
                              color: "#aaa",
                            }}
                          >
                            {item.name} / {item.email} / {item.nickname}
                          </PretendardText>
                          <RedBtn
                            style={{
                              backgroundColor: "transparent",
                            }}
                            onClick={() => {
                              setAddSearchSelectedList(
                                addSearchSelectedList.filter(
                                  (selectedItem) => selectedItem.id !== item.id
                                )
                              );

                              setSubmitValue({
                                ...submitValue,
                                memberIdList: submitValue.memberIdList.filter(
                                  (id) => id !== item.id
                                ),
                              });
                            }}
                          >
                            삭제
                          </RedBtn>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              {/* 사유 */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <PretendardText
                  style={{
                    fontSize: "15px",
                    fontWeight: "400",
                    lineHeight: "22px",
                    color: "#aaa",
                    marginBottom: 16,
                  }}
                >
                  사유
                </PretendardText>
                <MainInput
                  type={"text"}
                  placeholder={"내용을 입력해 주세요."}
                  style={{ width: "572px" }}
                  value={submitValue.reason}
                  onChange={(e) => {
                    setSubmitValue({
                      ...submitValue,
                      reason: e.target.value,
                    });
                  }}
                />
              </div>

              {/* 시작일-종료일 설정 */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <PretendardText
                  style={{
                    fontSize: "15px",
                    fontWeight: "400",
                    lineHeight: "22px",
                    color: "#aaa",
                    marginBottom: 16,
                  }}
                >
                  시작일-종료일 설정
                </PretendardText>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    marginBottom: 12,
                  }}
                >
                  <GrayBtn
                    onClick={() => {
                      setSubmitValue({
                        ...submitValue,
                        startDate: today,
                        endDate: getEndDate(today, "1주일"),
                      });
                    }}
                  >
                    1주일
                  </GrayBtn>
                  <GrayBtn
                    onClick={() => {
                      setSubmitValue({
                        ...submitValue,
                        startDate: today,
                        endDate: getEndDate(today, "1개월"),
                      });
                    }}
                  >
                    1개월
                  </GrayBtn>
                  <GrayBtn
                    onClick={() => {
                      setSubmitValue({
                        ...submitValue,
                        startDate: today,
                        endDate: getEndDate(today, "3개월"),
                      });
                    }}
                  >
                    3개월
                  </GrayBtn>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <DateInput
                    value={submitValue.startDate}
                    onChange={(e) => {
                      setSubmitValue({
                        ...submitValue,
                        startDate: e.target.value,
                      });
                    }}
                  />
                  <span
                    style={{
                      width: 6,
                      height: 1,
                      backgroundColor: "rgba(181, 181, 181, 0.5)",
                    }}
                  />
                  <DateInput
                    value={submitValue.endDate}
                    onChange={(e) => {
                      setSubmitValue({
                        ...submitValue,
                        endDate: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </PopupOverLay>
      )}
    </>
  );
};

export default UserPurchaseLimit;
